import { createSlice } from "@reduxjs/toolkit";

const initialActivityType = {
  name: ""
};

const initialActivityTypesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  authorities: null,
  activityType: initialActivityType
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const activityTypeSlice = createSlice({
  name: "activityTypes",
  initialState: initialActivityTypesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getActivityTypes
    activityTypesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getActivityType
    activityTypeFetched: (state, action) => {
      state.actionsLoading = false;      
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.activityType = action.payload.entity;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanActivityTypesState
    activityTypesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = [];
      state.activityType = initialActivityType;
    }
  }
});